import _jsx from "@babel/runtime/helpers/jsx";
var _CircularProgress;
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { compose } from 'redux';
import Grid from '@mui/material/Grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Collapse from '@mui/material/Collapse';
import Popover from '@mui/material/Popover';
import Button from '@mui/material/Button';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import IndeterminateCheckBoxOutlinedIcon from '@mui/icons-material/IndeterminateCheckBoxOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import _ from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';
import withWidth, { isWidthDown } from 'muiCompat/withWidth';
import withStyles from 'isomorphic-style-loader/withStyles';
import messages from '../coursesMessges';
import s from './CategoryCollapse.scss';
import { ModalCloseBtn } from '../../../components/statelessComponents/Buttons/ButtonsInModals';
import CircularProgress from '../../../components/CircularProgress';
import modalStyles from '../../../components/styles/Modal.scss'; // eslint-disable-line
import intlPropTypes from '../../../constants/intlPropTypes';
var CategoryCollapse = function CategoryCollapse(_ref) {
  var loadingCourses = _ref.loadingCourses,
    pendingCategories = _ref.pendingCategories,
    categories = _ref.categories,
    toggleSelectAllContentCategories = _ref.toggleSelectAllContentCategories,
    handleToggleContentCategory = _ref.handleToggleContentCategory,
    handleCollapseIndex = _ref.handleCollapseIndex,
    isIndexExpanded = _ref.isIndexExpanded,
    isLoadedContentCategories = _ref.isLoadedContentCategories,
    width = _ref.width,
    anchorEl = _ref.anchorEl,
    formatMessage = _ref.intl.formatMessage,
    nameMapper = _ref.nameMapper;
  var categoryContent = /*#__PURE__*/_jsx("div", {
    className: s.popoverContent
  }, void 0, loadingCourses && /*#__PURE__*/_jsx("div", {
    className: s.loadingWrapper
  }, void 0, _CircularProgress || (_CircularProgress = /*#__PURE__*/_jsx(CircularProgress, {
    size: 100
  }))), /*#__PURE__*/_jsx(Grid, {
    className: s.tagsGrid,
    spacing: 0,
    container: true
  }, void 0, /*#__PURE__*/_jsx(Grid, {
    sm: 12,
    item: true
  }, void 0, /*#__PURE__*/_jsx(FormControlLabel, {
    classes: {
      root: s.checkboxSelectAll
    },
    control: /*#__PURE__*/_jsx(Checkbox, {
      "data-test-id": "_VqR08HnZ_06mXzXf4w5I",
      checked: pendingCategories.length === categories.length && categories.length > 1,
      indeterminate: !!pendingCategories.length && pendingCategories.length !== categories.length,
      disabled: loadingCourses || categories.length <= 1,
      onClick: toggleSelectAllContentCategories,
      color: "primary",
      classes: {
        root: s.categoryCheckbox
      },
      icon: /*#__PURE__*/_jsx(CheckBoxOutlineBlankIcon, {
        className: s.checkboxIcon
      }),
      indeterminateIcon: /*#__PURE__*/_jsx(IndeterminateCheckBoxOutlinedIcon, {
        className: s.checkboxIcon
      }),
      checkedIcon: /*#__PURE__*/_jsx(CheckBoxOutlinedIcon, {
        className: s.checkboxIcon
      })
    }),
    label: formatMessage(messages.selectAllLabel)
  })), /*#__PURE__*/_jsx("div", {
    className: s.categories
  }, void 0, /*#__PURE__*/_jsx(Grid, {
    className: s.categoryColumn,
    container: true,
    direction: isWidthDown('xs', width) ? 'column' : 'row'
  }, void 0, categories.slice(0, Math.round(categories.length / 2)).map(function (category) {
    return /*#__PURE__*/_jsx(Grid, {
      sm: 12,
      item: true
    }, category._id, /*#__PURE__*/_jsx(FormControlLabel, {
      classes: {
        root: s.checkboxFormControl,
        label: s.checkboxFormControlLabel
      },
      control: /*#__PURE__*/_jsx(Checkbox, {
        "data-test-id": "psEid2_v3egYHj3KqlVg5",
        checked: pendingCategories.indexOf(category._id) !== -1,
        onClick: handleToggleContentCategory(category._id),
        disabled: loadingCourses,
        color: "primary",
        classes: {
          root: s.categoryCheckbox
        },
        icon: /*#__PURE__*/_jsx(CheckBoxOutlineBlankIcon, {
          className: s.checkboxIcon
        }),
        checkedIcon: /*#__PURE__*/_jsx(CheckBoxOutlinedIcon, {
          className: s.checkboxIcon
        })
      }),
      label: nameMapper(category)
    }));
  })), /*#__PURE__*/_jsx(Grid, {
    className: s.categoryColumn,
    container: true,
    direction: isWidthDown('xs', width) ? 'column' : 'row'
  }, void 0, categories.slice(Math.round(categories.length / 2)).map(function (category) {
    return /*#__PURE__*/_jsx(Grid, {
      sm: 12,
      item: true
    }, category._id, /*#__PURE__*/_jsx(FormControlLabel, {
      classes: {
        root: s.checkboxFormControl,
        label: s.checkboxFormControlLabel
      },
      control: /*#__PURE__*/_jsx(Checkbox, {
        "data-test-id": "j_3LMe2vRA38-d6BuzgZO",
        checked: pendingCategories.indexOf(category._id) !== -1,
        onClick: handleToggleContentCategory(category._id),
        disabled: loadingCourses,
        color: "primary",
        classes: {
          root: s.categoryCheckbox
        },
        icon: /*#__PURE__*/_jsx(CheckBoxOutlineBlankIcon, {
          className: s.checkboxIcon
        }),
        checkedIcon: /*#__PURE__*/_jsx(CheckBoxOutlinedIcon, {
          className: s.checkboxIcon
        })
      }),
      label: nameMapper(category)
    }));
  })))));
  if (isWidthDown('xs', width)) {
    return /*#__PURE__*/_jsx(Collapse, {
      classes: {
        container: s.collapseContainer
      },
      "in": isIndexExpanded && isLoadedContentCategories
    }, void 0, categoryContent, !_.isEmpty(pendingCategories) && /*#__PURE__*/_jsx(Button, {
      "data-test-id": "__qilsVdtqIyvJjpNGvEl",
      color: "primary",
      onClick: handleCollapseIndex,
      variant: "outlined",
      className: s.applyCategoryFilterBtn
    }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.applyCategoryFilter)));
  }
  return /*#__PURE__*/_jsx(Popover, {
    open: isIndexExpanded && isLoadedContentCategories,
    anchorEl: anchorEl,
    anchorReference: "anchorEl",
    anchorPosition: {
      top: 200,
      left: 400
    },
    onClose: handleCollapseIndex,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    classes: {
      paper: s.tagsIndexPopover
    }
  }, void 0, categoryContent, /*#__PURE__*/_jsx(ModalCloseBtn, {
    "data-test-id": "_neKlgBXWN6iEWji0Tzfe",
    onClick: handleCollapseIndex,
    className: classNames(modalStyles.closeModalBtn, s.categoryModalCloseBtn),
    "data-test": "category-modal-close-button"
  }));
};
export default compose(withWidth({
  withTheme: true
}), injectIntl, withStyles(modalStyles), withStyles(s))(CategoryCollapse);